import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

export default function CollaborationNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const activeKey = location.pathname.includes('/collaboration/shared-views')
    ? 'shared-views'
    : location.pathname.includes('/collaboration/teams')
      ? 'teams'
      : 'teams';

  const items = [
    { key: 'teams', label: t('collaboration.teams_title') },
    { key: 'shared-views', label: t('collaboration.shared_views_title') },
  ];

  return (
    <Tabs
      activeKey={activeKey}
      items={items}
      onChange={(key) => navigate(`/collaboration/${key}`)}
      style={{ marginBottom: 16 }}
    />
  );
}
